import {useRef, useLayoutEffect } from 'react';
import canUseDOM from '../../utilities/canUseDOM';

interface TrustBoxProps {
  businessUnitId?: string | null;
  trustBoxTemplateId: string;
  trustBoxHeight: string;
  productSku?: string | null;
}

declare global {
  interface Window {
    Trustpilot: {
      loadFromElement: Function;
    };
  }
}

const TrustBox = ({
  businessUnitId,
  trustBoxTemplateId,
  trustBoxHeight,
  productSku,
}: TrustBoxProps) => {
  const ref = useRef<HTMLDivElement>(null);

  useLayoutEffect(() => {
    if (canUseDOM()) {
      window.Trustpilot = window.Trustpilot || {};
      if (window.Trustpilot) {
        window.Trustpilot.loadFromElement(ref.current, true);
      }
    }
  }, []);

  return (
    <div
      ref={ref}
      className="trustpilot-widget"
      data-locale="en-GB"
      data-template-id={trustBoxTemplateId}
      data-businessunit-id={businessUnitId}
      data-style-height={trustBoxHeight}
      data-style-width="100%"
      data-theme="light"
      data-stars="1,2,3,4,5"
      data-sku={productSku}
    >
      <a
        href="https://www.trustpilot.com/review/example.com"
        target="_blank"
        rel="noopener noreferrer"
      >
        {' '}
        Trustpilot
      </a>
    </div>
  );
};
export default TrustBox;
